import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { AnalyticsTrackingEvent } from '../analytics/events.js';

var buildTrackingParams = function (_a) {
    var _b;
    var trackingParams = _a.trackingParams, mainEntity = _a.mainEntity;
    var queryParams = __assign({}, (trackingParams || {}));
    if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product') {
        queryParams.sku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.stacklineSku;
        queryParams.stacklineSku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.stacklineSku;
        queryParams.retailerId = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.retailerId;
        queryParams.retailerSku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.retailerSku;
        queryParams.brandId = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.brandId;
    }
    else if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'brand') {
        queryParams.brandId = (_b = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.id) === null || _b === void 0 ? void 0 : _b.toString();
    }
    return queryParams;
};
var trackRetailerProductPageEvent = function (_a) {
    var _b;
    var trackingEventAction = _a.trackingEventAction, trackingParams = _a.trackingParams, analyticsTrack = _a.analyticsTrack;
    if (analyticsTrack) {
        (_b = window === null || window === void 0 ? void 0 : window.dispatchEvent) === null || _b === void 0 ? void 0 : _b.call(window, new CustomEvent('bc-track', {
            bubbles: true,
            detail: __assign({ eventName: trackingEventAction }, trackingParams),
        }));
        var eventIndex = ['addToCart', 'openRetailerProductPage', 'navigateToRetailerProductPage'].indexOf(trackingEventAction);
        var eventToPublish = [
            AnalyticsTrackingEvent.WEB_APP_ORGANIC_ADD_TO_CART,
            AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE,
            AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE, // use same event for navigateToRetailerProductPage
        ][eventIndex];
        if (eventToPublish) {
            analyticsTrack(eventToPublish, __assign({}, trackingParams));
        }
        else {
            console.error("Event not configured for sending to analytics: ".concat(trackingEventAction));
        }
    }
};

export { buildTrackingParams, trackRetailerProductPageEvent };
//# sourceMappingURL=analytics.js.map
